import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CreNgModule, SpinnerModule } from 'cre-ng';
import { ButtonModule } from 'primeng/button';

import { ServiceFactory } from '@app/core/services/service.factory';
import { WigAwardsModule } from '@app/wig-awards/wig-awards.module';
import { WigBonusModule } from '@app/wig-bonus/wig-bonus.module';
import { WigFleetBannerModule } from '@app/wig-fleet-banner';
import { WigFleetCompetitionTrendModule } from '@app/wig-fleet-competition-trend';
import { WigStatsModule } from '@app/wig-stats/wig-stats.module';
import { WigWeeklyCompetitionDetailsModule } from '@app/wig-weekly-competition-details';
import { DriverTeamInformationModule } from '@app/driver-team-information';
import { TeamCompetitionChartModule } from '@app/team-competition-chart/team-competition-chart.module';
import { WigTabsComponent } from './wig-tabs.component';

@NgModule({
  declarations: [WigTabsComponent],
  exports: [WigTabsComponent],
  imports: [
    CommonModule,
    CreNgModule,
    FontAwesomeModule,
    ButtonModule,
    SpinnerModule,
    WigAwardsModule,
    WigBonusModule,
    WigFleetBannerModule,
    WigFleetCompetitionTrendModule,
    WigStatsModule,
    WigWeeklyCompetitionDetailsModule,
    DriverTeamInformationModule,
    TeamCompetitionChartModule,
  ],
  providers: [ServiceFactory],
})
export class WigTabsModule {
  constructor() {}
}
